import { chartNames, strCode } from "../index";

export const appsDashboardsOptions = {
  OVERVIEW: [
    {
      id: chartNames.PAGE_LOADS,
      value: strCode.PAGE_LOADS_TITLE
    },
    {
      id: chartNames.AVG_PAGE_LOAD_SPEED,
      value: strCode.AVG_PAGE_LOAD_SPEED_TITLE
    },
    {
      id: chartNames.CONNECTION_TIME,
      value: strCode.CONNECTION_TIME_TITLE
    },
    {
      id: chartNames.IQOS_DEVICE_CONNECTIONS_COUNT,
      value: strCode.IQOS_DEVICE_CONNECTIONS_TITLE
    },
    {
      id: chartNames.IQOS_DEVICE_USAGE,
      value: strCode.IQOS_DEVICE_USAGE
    },
    {
      id: chartNames.OS,
      value: strCode.OPERATING_SYSTEM_USAGE_TITLE
    },
    {
      id: chartNames.BROWSER,
      value: strCode.BROWSER_USAGE_TITLE
    }
  ],
  FIRMWARE: [
    {
      id: chartNames.FWU_STATISTICS,
      value: strCode.FWU_STATISTICS_SHORT_TITLE
    },
    {
      id: chartNames.FWU_PERFORMANCE,
      value: strCode.FWU_PERFORMANCE_SHORT_TITLE
    },
    {
      id: chartNames.FWU_COUNT,
      value: strCode.FWU_COUNT_SHORT_TITLE
    },
    {
      id: chartNames.FWU_ERRORS,
      value: strCode.FWU_ERRORS_SHORT_TITLE
    },
    {
      id: chartNames.RECONNECTION_TIME_DURING_FWU,
      value: strCode.RECONNECTION_TIME_DURING_FWU_TITLE
    }
  ],
  DIAGNOSTIC: [
    {
      id: chartNames.AD_STATISTICS,
      value: strCode.AD_STATISTICS_SHORT_TITLE
    },
    {
      id: chartNames.AD_COUNT,
      value: strCode.AD_COUNT_TITLE
    },
    {
      id: chartNames.DIAGNOSTICS_PERFORMANCE,
      value: strCode.DIAGNOSTICS_PERFORMANCE_TITLE
    },
    {
      id: chartNames.DIAGNOSTICS_ERRORS_READING_PERFOMANCE,
      value: strCode.DIAGNOSTIC_ERRORS_READING_PEROFOMANCE_TITLE
    }
  ],
  SETTINGS: [
    {
      id: chartNames.SETTING_USAGE,
      value: strCode.SETTING_USAGE_TITLE
    },
    {
      id: chartNames.SETTING_PERFOMANCE,
      value: strCode.SETTING_PERFOMANCE_TITLE
    }
  ],
  BATTERY_HEALTH: [
    {
      id: chartNames.BATTERY_HEALTH_STATISTICS,
      value: strCode.BATTERY_HEALTH_STATISTICS_TITLE
    },
    {
      id: chartNames.BATTERY_HEALTH_PERFORMANCE,
      value: strCode.BATTERY_HEALTH_PERFORMANCE_TITLE
    }
  ]
};
